import ordersQueryUrl from '../utils/ordersQueryUrl'
import { getHeaders } from './authentication'

// Initial State
const initialState = {
  all: [],
  filtersVisible: false,
  ordersQuery: {
    pharmacyID: null,
    status: '',
    region: null,
    reverse: true,
    pharmacy_id: null,
    limit: 10,
    page: 0,
    collection: false, delivery: false
  },
  ordersUrl: '/orders',
}

// Action constants
const ORDERS = 'ORDERS'
const ORDERS_SUCCESS = 'ORDERS_SUCCESS'
const ORDERS_FAILURE = 'ORDERS_FAILURE'
const SET_ORDERS_QUERY = 'SET_ORDERS_QUERY'
const SHOW_ORDER_FILTERS = 'SHOW_ORDER_FILTERS'
const HIDE_ORDER_FILTERS = 'HIDE_ORDER_FILTERS'
const CHANGE_ORDERS_LIMIT = 'CHANGE_ORDERS_LIMIT'
const CHANGE_ORDERS_PAGE = 'CHANGE_ORDERS_PAGE'
const CHANGE_ORDERS_STATUS = 'CHANGE_ORDERS_STATUS'
const CHANGE_ORDER_DELIVERY_METHOD = 'CHANGE_ORDER_DELIVERY_METHOD'
const CHANGE_PHARMACY_FILTER = 'CHANGE_PHARMACY_FILTER'
const CHANGE_REGION_FILTER = 'CHANGE_REGION_FILTER'

// Action creators
export const getOrders = query => {
  const url = ordersQueryUrl('orders/prioritized', query)
  return {
    types: [ORDERS, ORDERS_SUCCESS, ORDERS_FAILURE],
    payload: {
      request: {
        url, method: 'GET', headers: getHeaders()
      }
    },
  }
}

export const setOrdersQuery = query => {
  return {
    type: SET_ORDERS_QUERY,
    payload: query,
  }
}

export const showOrderFilters = () => {
  return {
    type: SHOW_ORDER_FILTERS,
  }
}

export const hideOrderFilters = () => {
  return {
    type: HIDE_ORDER_FILTERS,
  }
}

export const changeOrdersLimit = (limit) => {
  return {
    type: CHANGE_ORDERS_LIMIT, payload: limit
  }
}

export const changeOrdersPage = (page) => {
  return {
    type: CHANGE_ORDERS_PAGE, payload: page
  }
}

export const changeOrdersStatus = (status) => {
  return {
    type: CHANGE_ORDERS_STATUS, payload: status
  }
}

export const changeDeliveryMethod = (method) => {
  return {
    type: CHANGE_ORDER_DELIVERY_METHOD, payload: method
  }
}

export const changePharmacyFilter = (pharmacyID) => {
  return {
    type: CHANGE_PHARMACY_FILTER, payload: pharmacyID
  }
}

export const changeRegionFilter = (regionID) => {
  return {
    type: CHANGE_REGION_FILTER, payload: regionID
  }
}

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PHARMACY_FILTER:
      return { ...state, ordersQuery: { ...state.ordersQuery, pharmacyID: action.payload } }
    case CHANGE_REGION_FILTER:
      return { ...state, ordersQuery: { ...state.ordersQuery, regionID: action.payload } }
    case CHANGE_ORDER_DELIVERY_METHOD:
      return { ...state, ordersQuery: { ...state.ordersQuery, collection: action.payload === 'collection', delivery: action.payload === 'delivery' } }
    case CHANGE_ORDERS_STATUS:
      return {
        ...state, ordersQuery: { ...state.ordersQuery, status: action.payload }
      }
    case CHANGE_ORDERS_LIMIT:
      return { ...state, ordersQuery: { ...state.ordersQuery, limit: Number(action.payload) } }
    case CHANGE_ORDERS_PAGE:
      return { ...state, ordersQuery: { ...state.ordersQuery, page: Number(action.payload) } }
    case ORDERS:
      return { ...state, error: null }
    case ORDERS_SUCCESS:
      return {
        ...state, orders: action.payload?.data?.data, totalOrders: action.payload?.data?.pagination?.count
      }
    case ORDERS_FAILURE:
      return {
        ...state, error: action.error.text
      }
    case SHOW_ORDER_FILTERS:
      return {
        ...state,
        filtersVisible: true,
      }
    case HIDE_ORDER_FILTERS:
      return {
        ...state,
        filtersVisible: false,
      }
    case SET_ORDERS_QUERY:
      return {
        ...state,
        ordersQuery: action.payload,
        ordersUrl: ordersQueryUrl('orders', action.payload),
      }
    default:
      return state
  }
}

export default ordersReducer;
